import React from 'react'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory, match } from 'react-router';

import NavLink from '../Routes/NavLink'

import { owners } from '../../core/controllers/Owners'

export default class OwnersList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            owners: null
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        owners.getOwners(function(response) {
            self.setState({
                owners: response.data
            })
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatLastLogin(cell, row) {
        return moment.utc(row.last_login).local().format('MMMM Do YYYY, h:mm:ss a');
    }

    formatJoinDate(cell, row) {
        return moment(row.created_at).format('MMMM Do YYYY');
    }

    formatActionOptions(cell, row) {
        if (!row.has_account){
            return (
                <div>
                    <span class="important-small-orange">Pending Account</span>
                </div>
            )
        } else if (row.waiting_payment_account){
            return (
                <div>
                    <span class="important-small-orange">Pending Payment Setup</span>
                </div>
            )
        }
    }

    didSelectRow(row) {
        browserHistory.push('/owner/' + row.owner_id);
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    render(){
        var self = this;
        var owners = this.state.owners;
        const options = {
            onRowClick: this.didSelectRow
        };

        if(owners !== null) {
            owners = this.state.owners.map(function(owner) {
                const formatData = {
                    owner_id: owner.owner.owner_id,
                    address: owner.owner.address,
                    city: owner.owner.city,
                    company_name: owner.owner.company_name,
                    created_at: owner.owner.created_at,
                    name: owner.owner.name,
                    property_count: owner.property_count,
                    has_account: (owner.user != null && owner.user.password != null) ? true : false,
                    waiting_payment_account: (owner.user != null && owner.user.checkbook_api_key != null) ? false : true,
                };

                return formatData;
            });
        }

        return (
            <div class="content">
                {owners != null ? (
                    window.innerWidth < 992 ? (
                    <BootstrapTable data={owners} version='4' striped search pagination hover options={options}>
                        <TableHeaderColumn dataField='owner_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='company_name' dataSort={ true }>Company</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_count' dataSort={ true }>Total Properties</TableHeaderColumn>
                    </BootstrapTable>
                    ) : (
                    <BootstrapTable data={owners} version='4' striped search pagination hover options={options}>
                        <TableHeaderColumn dataField='owner_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='company_name' dataSort={ true }>Company</TableHeaderColumn>
                        <TableHeaderColumn dataField='name' dataSort={ true }>Owner Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='address' dataSort={ true }>Address</TableHeaderColumn>
                        <TableHeaderColumn dataField='city' dataSort={ true }>City</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_count' dataSort={ true }>Total Properties</TableHeaderColumn>
                        <TableHeaderColumn dataField='created_at' dataFormat={this.formatJoinDate} dataSort={ true }>Date Created</TableHeaderColumn>
                        <TableHeaderColumn dataAlign='right' dataFormat={this.formatActionOptions}></TableHeaderColumn>
                    </BootstrapTable>
                    )
                ) : (
                    <p>No owners yet.</p>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Owners/OwnersList.jsx